import React from "react";
import Modal from "react-bootstrap/Modal";
import AppStyles from "../../config/styles";
import { Div } from "../atoms/Div";
import SensitiveAreaImg from "../../../src/images/sensitive_area_logo.svg"
import { AddChildCloseIcon, ImgSeparator } from "../atoms/ConnectStories";
import { useSelector } from "react-redux";

const styles = {
  modal: {
    justifyContent: "flex-end",
    margin: 0,
    padding: "1%",
  },
  viewstyle: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "15px"
  },
  viewLine: {
    alignSelf: "center",
    backgroundColor: AppStyles.colors.COLOR_GREYE6,
    marginTop: "6px",
    height: "4px",
    width: "96px",
  },
  iconstyle: {
    marginTop: "25px",
    marginLeft: "6%",
  },
  titlestyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "25px",
    color: "black",
    margin: "0px 15px",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  desstyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "18px",
    color: "black",
    marginTop: "15px",
    marginLeft: "20px",
    marginRight: "15px",
    textAlign: "center",
  },
  galleryviewstyle: {
    borderRadius: 8,
    backgroundColor: AppStyles.colors.COLOR_ORANGE,
    margin: "3% auto",
    textAlign: "center",
    padding: "2% 5%",
    minWidth: "175px",
    boxShadow: "rgba(199, 83, 0, 0.4) 0 2px 4px,rgba(199, 83, 0, 0.3) 0 7px 13px -3px,#C75300 0 -3px 0 inset",
  },
  gallerytextstyle: {
    color: AppStyles.colors.COLOR_WHITE,
    fontSize: "20px",
    fontFamily: "Lato-Bold",
    cursor: "pointer"
  },
  camerapressstyle: {
    textAlign: "center",
    margin: "0 0 5% 0"
  },
  cameratextstyle: {
    fontSize: "18px",
    color: AppStyles.colors.COLOR_GREY3,
    alignSelf: "center",
    marginLeft: 10
  },
  checkbox: {
    width: 16,
    height: 16,
    cursor: "Pointer",
  },
  SensitiveAreaImg: {
    maxWidth: "20%",
    margin: "auto"
  }
};

function SensitiveModalComponent(props) {
  const [checked, setChecked] = React.useState(false);
  const { loginReducer } = useSelector((state) => state);
  const { persistItemsReducer } = useSelector((state) => state);

  const handleChange = () => {
    setChecked(!checked);
  }

  function getCookie(name) {
    let re = new RegExp(name + "=([^;]+)");
    let value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
  }

  const setCookie = (expiryMonths) => {
    let now = new Date();
    let time = now.getTime();
    let expireTime = time + expiryMonths * 1000 * 3600 * 24 * 30;
    now.setTime(expireTime);
    document.cookie = persistItemsReducer?.sponsorID + "=" + "DisableSensitive" + ";expires = " + now.toUTCString() + ";path=/";
  }

  const handleProceed = () => {
    const expiryMonths = checked ? 12 : loginReducer?.getSOConfiguration?.letterTemplateSettings?.sensitiveDisplayDurationInMonths;
    setCookie(expiryMonths)
    props?.onOkClick()
  }

  const handleCloseClick = () => {
    if (props?.showSensitiveAreaCheckbox) {
      setCookie(loginReducer?.getSOConfiguration?.letterTemplateSettings?.sensitiveDisplayDurationInMonths);
    }
    props?.onClose();
  }

  return (
    <Modal
      show={props?.isVisible}
      style={styles.modal}
    >
      <AddChildCloseIcon onClick={handleCloseClick}>X</AddChildCloseIcon>
      <img src={SensitiveAreaImg} style={styles.SensitiveAreaImg} alt="" />
      <div style={styles.viewstyle}>
        <span style={styles.titlestyle}>{props?.title}</span>
        <ImgSeparator sensitive></ImgSeparator>
        <Div flexdiv>
          <p style={styles.desstyle}>{props?.description}</p>
        </Div>
        <Div flexdiv draftSaveButton onClick={handleProceed}>
          <div style={styles.galleryviewstyle}>
            <span style={styles.gallerytextstyle}>{props?.okText}</span>
          </div>
        </Div>
        {props?.showSensitiveAreaCheckbox && (getCookie(persistItemsReducer?.sponsorID) == null || getCookie(persistItemsReducer?.sponsorID) != "DisableSensitive") &&
          <Div style={styles.camerapressstyle}>
            <input
              id="html"
              type="checkbox"
              checked={checked}
              onChange={handleChange}
              style={styles.checkbox}
            />
            <label style={styles.cameratextstyle}>{props?.checkText}</label>
          </Div>
        }
      </div>
    </Modal>
  );
}

export default SensitiveModalComponent;
